<template>
  <!-- dialog confirm request order / teruskan pesanan -->
  <v-dialog
    v-model="dialogAnnouncement"
    persistent
    scrollable
    max-width="96%"
    style="overflow: hidden!important;"
  >
    <v-card>
      <v-card-title class="text-h6 text-h6 text-capitalize dark--text">
        <span>Daftar Harga Produk DSN</span>
      </v-card-title>

      <v-card-text class="mt-3 text-center" style="min-height: 400px;">
        <v-row>
          <v-col cols="12" md="12" v-if="!loading">
            <v-row>
              <template v-for="(item, idx) in listProductAll">
                <v-col cols="12" md="2" :key="idx">
                  <v-card
                    class="rounded d-flex flex-column justify-space-between"
                    rounded
                    style="height: 100%;"
                  >
                    <v-img
                      height="200"
                      cover
                      :src="item.product_image"
                      style="background-position: center center; background-repeat: no-repeat; background-size: cover;"
                      :style="{ backgroundImage: `url(${require('@/assets/no-image-post.png')})` }"
                    ></v-img>

                    <v-card-title><h6 class="product-info-title text-left" :title="item.product_name">{{ item.product_name }}</h6></v-card-title>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text>
                      <div class="d-flex flex-row align-center justify-space-between text-left mb-1">
                        <strong>Umum</strong>
                        <span class="text-right">{{ item.product_popup_general_price | toRupiah }}</span>
                      </div>
                      <div class="d-flex flex-row align-center justify-space-between text-left" style="color: #8C2409;">
                        <strong>Member</strong>
                        <span class="text-right">{{ item.product_popup_member_price | toRupiah }}</span>
                      </div>
                    </v-card-text>
                  </v-card>

                </v-col>
              </template>
            </v-row>
          </v-col>

          <v-col cols="12" md="12" class="pa-0" v-else>
            <v-skeleton-loader
              v-bind="attrs"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-row class="text-center">
          <v-btn
            outlined
            class="my-4 px-5 text-capitalize"
            :loading="loadingStatus"
            @click="dialogAnnouncement = false"
          >
            Tutup
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      loadingStatus: false,
      dialogAnnouncement: false,
      slides: 0,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      }
    }
  },
  computed: {
    ...mapState('product', ['listProductAll', 'listProductMitra']),
  },
  methods: {
    ...mapActions('product', ['getProductAll', 'getProductMitra']),
    
    modalShow() {
			this.dialogAnnouncement = true
		},
    modalHide() {
			this.dialogAnnouncement = false
		},
    prosesForwardPesananAct(item) {
      this.$emit('action', item)
    },
  },
  async mounted() {
    this.loading = await true
    // await this.getAnnouncements()
    this.getProductAll()
    this.getProductMitra()
    // if (this.announcement.length > 0) await this.modalShow()
    this.modalShow()

    setTimeout(() => {
      this.loading = false
    }, 1000);
  },
}
</script>

<style lang="scss" scoped>
  .announce-content {
    position: relative;
    overflow: hidden;
  }
  .announce-content .d-content {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding: 2rem 3rem 60px;
    background: rgba(0,0,0,0.05);
    backdrop-filter: blur(50px);
    font-weight: 550;
    color: #111;
    display: block!important;
    font-size: 16px!important;
  }
  .announce-content .d-content p {
    margin-bottom: 0!important;
  }

  .announce-content:hover .d-content {
    background: rgba(0,0,0,0.75);
    backdrop-filter: blur(50px);
    color: #fff;
  }

  .product-info-title {
    line-height: 140%!important;
    height: 40px;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* start showing ellipsis when 3rd line is reached */
    white-space: pre-wrap; /* let the text wrap preserving spaces */
  }
</style>